export const SEARCH_INTENTS = [
  'informational',
  'commercial',
  'transactional',
  'navigational',
] as const

/** The search intent a provider reads for a keyword; shared search vocabulary. */
export type SearchIntent = (typeof SEARCH_INTENTS)[number]
